import {RegisterType} from '../component-registry';
import {GuidedUiFeaturedQuicklinks} from '../../models/Guided.schema';
import {GuidedQuickLinkDetails} from '../../models/quick-link';
import {onlyMatchingSource} from '../../utils';
import {type SelectedSuggestion, SelectedSuggestions} from '../selected-suggestions/selected-suggestions';
import {h} from '@stencil/core';
import type {GuidedV2FactoryState} from '../../models/ui';
import type {GuidedItemV2} from '../../models/models';



export class GuidedV2FeaturedQuickLinks {
  @RegisterType(GuidedUiFeaturedQuicklinks.type)
  render<T extends GuidedQuickLinkDetails>(
    inputData: GuidedUiFeaturedQuicklinks,
    state: GuidedV2FactoryState<T>,
  ) {
      const {
        itemSources,
        slots,
      } = inputData; //comes from configuration

      const {
        labelProvider,
        eventEmitters,
        results, //the API response
      } = state;

      const matchingResults = results
        .filter(onlyMatchingSource(itemSources))
        .slice(0, slots)
        .map((item: GuidedItemV2) => ({
          suggestionURL: item.details.quickLinkOpenUrl,
          suggestionTitle: item.details.quickLinkTitle,
          suggestionDescription: item.details.quickLinkDescription ?? '',
          suggestionImage: item.details.quickLinkImage ?? '',
        })) as SelectedSuggestion[]
    ;
      return <SelectedSuggestions
        results={matchingResults}
        label={labelProvider('guided-v2.featured-suggestions.label', 'Featured Suggestions')}
        eventEmitters={eventEmitters}
      />;
  }
}
